/**
 * Checklist d'évaluation : completions + preuves textuelles ou liens.
 */

import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface ChecklistState {
  completions: Record<string, boolean>;
  proofs: Record<string, string>;
  toggleItem: (itemId: string) => void;
  setItemProof: (itemId: string, proof: string) => void;
}

export const useChecklistStore = create<ChecklistState>()(
  devtools(
    persist(
      (set) => ({
        completions: {},
        proofs: {},

        toggleItem: (itemId) => {
          set((state) => ({
            completions: { ...state.completions, [itemId]: !state.completions[itemId] },
          }));
        },

        setItemProof: (itemId, proof) => {
          set((state) => ({
            proofs: { ...state.proofs, [itemId]: proof },
          }));
        },
      }),
      {
        name: 'saas-front-v2:tech-tests-checklist',
        version: 1,
        partialize: (state) => ({
          completions: state.completions,
          proofs: state.proofs,
        }),
        // Aucune version antérieure n'existe : `migrate` n'est atteint que sur un
        // payload d'origine inconnue, dont la forme n'est pas garantie — on repart
        // d'une checklist vide.
        // ⚠️ Au prochain bump, adapter AVANT ce retour en comparant avec `<` :
        // `if (oldVersion < 2) { …adapter… }`. Ne jamais tester
        // `oldVersion === <version courante>` : zustand n'appelle `migrate` que si
        // les versions diffèrent, la branche serait morte. Cascade de référence :
        // `use-layout-store`. (SAAS-903)
        migrate: () => ({ completions: {}, proofs: {} }),
      },
    ),
    { name: 'checklist', enabled: import.meta.env.DEV },
  ),
);
